<template>
  <li
    ref="liMediaRef"
    class="slide-media"
  >
    <MediaSlide
      :source="source"
      :media="meta"
      :is-mobile="isMobile"
      :is-visible="isVisible"
      :is-current="isCurrent"
      :can-reveal-resolved-media="canRevealResolvedMedia"
      :show-blocking-loader="showBlockingLoader"
      :can-skip-loader="canSkipLoader"
      @media-clicked="(element, event) => emit('mediaClicked', element, event)"
      @presentation-ready-change="(ready) => emit('presentationReadyChange', ready)"
      @skip-loader="emit('skipLoader')"
    />
  </li>
  <li
    class="slide-info"
    ref="liMetaRef"
  >
    <MetaSlide
      :source="source"
      :meta="meta"
      :active-ratings="activeRatings"
      :is-mobile="isMobile"
      @delete="(tag) => emit('delete', tag)"
      @add="(tag) => emit('add', tag)"
      @rate="(key, newRating) => emit('rate', key, newRating)"
    />
  </li>
</template>

<script setup lang="ts">
import { ref } from "vue";
import MetaSlide from "@/components/slides/MetaSlide.vue";
import MediaSlide from "@/components/slides/MediaSlide.vue";
import type {
  MediaMetaSlideGroupEmits as Emits,
  MediaMetaSlideGroupExposed as Exposed,
  MediaMetaSlideGroupProps as Props,
} from "@/components/slides/slideTypes";
import { MEDIA_SLIDE_PROPS_DEFAULTS } from "@/components/slides/slideTypes";

const props = withDefaults(
  defineProps<Props>(),
  MEDIA_SLIDE_PROPS_DEFAULTS,
);
const emit = defineEmits<Emits>();

const liMediaRef: Exposed["liMediaRef"] = ref<HTMLLIElement>();
const liMetaRef: Exposed["liMetaRef"] = ref<HTMLLIElement>();
defineExpose<Exposed>({
  liMediaRef,
  liMetaRef,
});
</script>

<style lang="scss" scoped>
.slide-info {
  padding: 1.4rem;

  background-color: #2a2a29;
  color: white;

  .root.viewer-mobile & {
    height: auto;
  }
  .root.viewer-desktop & {
    overflow-y: auto;
    max-width: 400px;
    min-width: 250px;
  }
}

</style>
